export default class GuiaConstantes {
  static ESTADO_DEVOLUCION = 'REDGUI';
  static ESTADO_RECEPCIONADO = 'RECGUI';
  static ESTADO_RECHAZADO = 'REZGUI';
  static ESTADO_REGISTRADO = 'REGGUI';
  static ESTADO_TRASLADO = 'RETGUI';
}
